const IMAGES = {
  profileCardSearch: 'https://i.wlycdn.com/articles/profile-card-search.svg',
  infoIcon: 'https://i.wlycdn.com/articles/info-icon-light-purple-ico.svg',
  playStore: 'https://i.wlycdn.com/articles/play-store-with-theme-bg.svg',
  appStore: 'https://i.wlycdn.com/articles/app-store-with-theme-bg.svg',
  wealthyLogo: 'https://i.wlycdn.com/articles/wealthy-logo-light-purple.svg',
  mainColorWealthyLogo: 'https://i.wlycdn.com/wealthy-home-page/wealthy-new-purple-logo.svg',
  successIconImage: 'https://i.wlycdn.com/wealthy-kyc/kyc-success-tick.svg',
  infoIconImage: 'https://i.wlycdn.com/family-flow/crn-info-icon.svg',
  fileUploadImage: 'https://i.wlycdn.com/wealthy-home-page/upload-cloud-icon.png',
  deleteImage: 'https://i.wlycdn.com/wealthy-home-page/partner-close-button.svg',
  crossIcon: 'https://i.wlycdn.com/articles/cross-icon.svg',
  phonePe: 'https://i.wlycdn.com/articles/phone-logo-png.png',
  gpay: 'https://i.wlycdn.com/articles/gpay-logo.png',
  paytm: 'https://i.wlycdn.com/articles/paytm-logo-v2.svg',
  bharathPay: 'https://i.wlycdn.com/articles/bharath_pay_icon_svg.svg',
  upiLogo: 'https://i.wlycdn.com/articles/upi-logo-svg.svg',
  whatsapp: 'https://i.wlycdn.com/articles/whatsapp-green-icon.svg',
  arrowHeadRight: 'https://i.wlycdn.com/wealthy-home-page/partners-button-right-arrow.svg',
  closeImage: 'https://i.wlycdn.com/articles/cross-cancel-black-filled-icon.svg',
  supportIcon: 'https://i.wlycdn.com/icons/pst-support-icon.png',
  digilockerIcon: 'https://i.wlycdn.com/articles/digilocker-icon-stars.png',
  uploadPanIcon: 'https://i.wlycdn.com/articles/pan-upload-4x-res.png',
  backIcon: 'https://i.wlycdn.com/articles/arrow-left-purple.svg',
  handsBadge: 'https://i.wlycdn.com/articles/hands-badge.png',
  greenTickFilled: 'https://i.wlycdn.com/articles/tick-icon-dark-green.svg',
  fileIcon: 'https://i.wlycdn.com/articles/list_chat_statement_icon.svg',
  lockIcon: 'https://i.wlycdn.com/wealthy-home-page/tax-saver-lock.svg',
  signatureImage: 'https://i.wlycdn.com/wealthy-kyc/digital-signature',
  specimenSign: 'https://i.wlycdn.com/articles/specimen-sign-illustration-with-instructions.png',
  digiLocker: 'https://i.wlycdn.com/wealthy-kyc/digi-locker.svg',
  selfieUpload: 'https://i.wlycdn.com/articles/selfie-illustration.png',
  selfieGuidelines: 'https://i.wlycdn.com/articles/illustrations_selfie_png.png',
  mandateImg: 'https://i.wlycdn.com/icons/emandate-success.png',
  arnCard: 'https://i.wlycdn.com/articles/Arn-card-without-background.png',
  questionMark: 'https://i.wlycdn.com/articles/question-mark-circled.png',
  arrowRight: 'https://i.wlycdn.com/articles/arrow-right-black.svg',
  arrowRightBlack : "https://i.wlycdn.com/wealthy-home-page/arrow-right.svg",
  arnDetected: 'https://i.wlycdn.com/wealthy-kyc/arn-detected.svg',
  arnFailed: 'https://i.wlycdn.com/wealthy-kyc/arn-failed.svg', 
  shieldPlusHeart: 'https://i.wlycdn.com/articles/shield-plus-heart.svg',
  arrowUptrendIcon: 'https://i.wlycdn.com/broking/arrow-uptrend-icon.png',
  clockIcon: 'https://i.wlycdn.com/articles/clock-timer-icon.svg',
  yellowTick: 'https://i.wlycdn.com/articles/thick-tick-yellow-icon.svg',
  aadhaar_number_image: 'https://i.wlycdn.com/articles/e-sign-illustration.png',
  bankIcon: 'https://i.wlycdn.com/articles/bank-icon-vector.svg',
  phone_icon: 'https://i.wlycdn.com/articles/phone-icon-vector.svg',
  verifying_clock: 'https://i.wlycdn.com/articles/clock-timer-icon.svg',
  caution_icon: 'https://i.wlycdn.com/articles/exclaimation-caution-icon.svg',
  cancel_cheque : 'https://i.wlycdn.com/articles/cancel-cheque.png',
  digilocker_instruction : "https://i.wlycdn.com/articles/digi_locker_instruction.gif",
  add_fund : 'https://i.wlycdn.com/articles/add-fund.svg'
};

export default IMAGES;
